import Chat from '~/pages/chat/chat.controller';
import { makeRoute } from '~/utils/route';
import template from './chat.html';
import ChatConstants from '~/pages/chat/chat.constant';

export default makeRoute({
	template,
	controller: Chat,
	path: ChatConstants.chatURL,
	title: 'common.workspace',
});
